import React from 'react';
import CalculatedField from '../CalculatedField/index';
import { checkCondition } from '../../utility/filterSchema';
import convertUnitMoney from '../../../../utility/convertUnitMoney';
import FormUIOptions from '../../formElements/formUIOptions';

export default function TableField({
  percentageValue,
  annualValue,
  field,
  fieldValue,
  data,
  sectionType,
  dropDowns,
  handleDropDown,
}) {
  if (!Array.isArray(fieldValue)) return null;
  const { schema, label } = field;
  if (!Array.isArray(schema)) return null;

  return (
    <>
      {label && (
        <h3 className="w-full text-center font-medium tracking-wide text-neutral-600  text-base">
          {label}
        </h3>
      )}
      {fieldValue.map((entry, i) => {
        const combinedData = { ...data, ...entry };

        if (entry[schema[1].name] === 'DELETED') return null;

        // if the schema has more than 2 fields, return a table of the values, otherwise return a single field with the first schema entry value as the label
        return schema.length > 2 ? (
          <React.Fragment key={i}>
            {schema.map((tableField, i) => {
              if (tableField.condition) {
                const conditionMet = checkCondition(
                  tableField.condition,
                  combinedData
                );
                if (!conditionMet) return null;
              }

              const valueToUse =
                tableField.type === FormUIOptions.UnitMoney
                  ? convertUnitMoney(entry[tableField.name], data)
                  : entry[tableField.name];

              return (
                <CalculatedField
                  key={`${tableField.name} + ${i}`}
                  percentageValue={
                    percentageValue || tableField.mainValue === 'percent'
                  }
                  annualValue={annualValue}
                  field={tableField}
                  fieldValue={valueToUse}
                  data={combinedData}
                  sectionType={sectionType}
                  dropDowns={dropDowns}
                  handleDropDown={handleDropDown}
                />
              );
            })}
          </React.Fragment>
        ) : (
          <CalculatedField
            key={i}
            percentageValue={percentageValue}
            annualValue={annualValue}
            field={{
              ...schema[1],
              type:
                schema[1].type === FormUIOptions.UnitMoney
                  ? FormUIOptions.Money
                  : schema[1].type,
              label: entry[schema[0].name] || `${schema[1].label} ${i + 1}`,
            }}
            fieldValue={
              schema[1].type === FormUIOptions.UnitMoney
                ? convertUnitMoney(entry[schema[1].name], data)
                : entry[schema[1].name]
            }
            data={combinedData}
            sectionType={sectionType}
            dropDowns={dropDowns}
            handleDropDown={handleDropDown}
          />
        );
      })}
    </>
  );
}
